import { useNavigate } from 'react-router-dom';

import IconContainer from './IconContainer';
import { ReactComponent as BackIcon } from '../icons/arrow-left.svg';

const HeadlinePanel = ({ type, label }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate('/home');
        }
    };


    return (
        <>
            <div className='mainHeader'>
                <div className='mainHeadLine'>
                    {type!=='' && <IconContainer Icon={BackIcon} label='Назад' onClick={handleBack} size = '20' color = 'black' className = '' /> }
                    <h1>{label || 'Страница'}</h1>
                </div>
            </div>
        </>
    )
}

export default HeadlinePanel;